import { Link, Stack } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { ArchivedWorkPackagesList } from "./archived-work-packages-list"

export function ArchivedWorkPackagesPage() {
    const navigate = useNavigate()

    const parentCrumbs = [
        <Link key="home" sx={{ cursor: "pointer" }} onClick={goHome}>
            Home
        </Link>,
    ]

    return (
        <PageBreadcrumbContainer heading="Archived Work Packages" parentCrumbs={parentCrumbs}>
            <Stack spacing={1} sx={{ width: 1, flex: 1, minHeight: 0, mt: 1, overflowY: "auto" }}>
                <ArchivedWorkPackagesList />
            </Stack>
        </PageBreadcrumbContainer>
    )

    function goHome() {
        navigate("/authoring")
    }
}
